<script setup lang="ts">
import { computed } from 'vue';
import { pgettext } from '@integro/gettext';

const props = withDefaults(
  defineProps<{
    error?: Error | string | null;
    reloading?: boolean;
  }>(),
  {
    error: null,
    reloading: false,
  },
);

const emit = defineEmits<{
  (e: 'reload'): void;
}>();

const msgFailed = pgettext('LoadError', 'Failed to load.');
const msgReload = pgettext('LoadError', 'Reload');

const detail = computed(() => {
  const error: any = props.error;
  if (!error) {
    return '';
  }
  if (typeof error === 'string') {
    return error;
  }
  const respData = error.response && error.response.data;
  if (respData) {
    if (typeof respData === 'string') {
      return respData;
    }
    if (respData.message || respData.error || respData.detail) {
      return String(respData.message || respData.error || respData.detail);
    }
  }
  return error.message || error.error || String(error);
});
</script>

<template>
  <div
    class="itp-load-error d-flex flex-column align-items-center justify-content-center text-center p-4"
    role="alert"
  >
    <p class="itp-load-error__title fw-semibold mb-1">{{ msgFailed }}</p>
    <p v-if="detail" class="itp-load-error__detail text-danger small mb-3">
      {{ detail }}
    </p>
    <ItpButton
      variant="primary"
      :spinning="reloading"
      :disabled="reloading"
      @click="emit('reload')"
    >
      {{ msgReload }}
    </ItpButton>
  </div>
</template>

<style scoped>
.itp-load-error__detail {
  max-width: 40rem;
  word-break: break-word;
}
</style>
